export default {
  API_BASE_URL: 'https://api.slt.attrecto-dev.com/api',
  STORAGE_BASE_URL: 'https://app.slt.attrecto-dev.com',
  ADMIN_URL: 'https://admin.slt.attrecto-dev.com',
  PRIVACY_POLICY: 'https://admin.slt.attrecto-dev.com/privacy-policy',
  TERMS_AND_CONDITIONS: 'https://admin.slt.attrecto-dev.com/terms-and-conditions',
};
